const app = 'genie';

export enum Operation {
  selectSession,
  pingParent,
  childWasClosed,
}

interface SelectSessionMessage {
  op: Operation.selectSession;
  sessionId: string;
}

interface PingParentMessage {
  op: Operation.pingParent;
}

interface ChildWasClosedMessage {
  op: Operation.childWasClosed;
  lastSessionId: string;
}

type Message = SelectSessionMessage | PingParentMessage | ChildWasClosedMessage;

const generateMessage = (message: Message) => ({
  app,
  ...message,
});

export const validateMessage = (e: MessageEvent): Message | undefined => {
  if (e && e.data && typeof e.data === 'object' && e.data.app === app) {
    return e.data;
  }

  return undefined;
};

export const messages = {
  selectSession: (sessionId: string): Object => generateMessage({ op: Operation.selectSession, sessionId }),
  pingParent: (): Object => generateMessage({ op: Operation.pingParent }),
  childIsClosed: (lastSessionId: string): Object => generateMessage({ op: Operation.childWasClosed, lastSessionId }),
};
